import { RootState } from "@src/reducers/store";
import React, { ReactNode, useState, useEffect } from "react";
import { useSelector } from "react-redux";

interface RenderIfUserHasMultiplePermissionProps {
  children: ReactNode;
  permissions: string | string[];
  invert?: boolean;
  requireAll?: boolean;
}

export const RenderIfUserHasMultiplePermissions = ({
  children,
  permissions,
  invert = false,
  requireAll = false,
}: RenderIfUserHasMultiplePermissionProps) => {
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    if (authContext && Array.isArray(authContext.permissions)) {
      const userPermissions = Array.isArray(permissions)
        ? permissions
        : [permissions];
      const match = requireAll
        ? userPermissions.every((permission) =>
            authContext.permissions.includes(permission),
          )
        : userPermissions.some((permission) =>
            authContext.permissions.includes(permission),
          );
      setHasPermission(match);
    } else {
      setHasPermission(false);
    }
  }, [authContext, permissions, requireAll]);

  if (invert) {
    return !hasPermission ? <>{children}</> : null;
  } else {
    return hasPermission ? <>{children}</> : null;
  }
};
